import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false } }
);

// 2026-05-27: Supabase enforces a default max_rows=1000 cap on every PostgREST
// query regardless of what .limit() you pass. Use fetchAll to page through.
// Pass a builder fn that returns a query — the helper appends .range(from, to)
// and loops until a short page returns. Safety cap at 100k rows to prevent
// runaway pagination on a bug.
export async function fetchAllPages(builderFn, pageSize = 1000) {
  let all = [];
  let from = 0;
  const HARD_CAP = 100000;
  while (true) {
    const { data, error } = await builderFn(from, from + pageSize - 1);
    if (error || !data) break;
    all = all.concat(data);
    if (data.length < pageSize) break;
    from += pageSize;
    if (from >= HARD_CAP) break;
  }
  return all;
}

export default supabase;
